import { useCallback } from "react";
import { useTheme } from "@mui/material/styles";
export const useToolHandlers = ({ svgCanvasInstanceRef, setTool, wallWidth, textValue, setTextValue, }) => {
    const theme = useTheme();
    const handleAddWall = useCallback((startPoint, endPoint) => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas)
            return;
        const lineElem = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: startPoint.x,
                y1: startPoint.y,
                x2: endPoint.x,
                y2: endPoint.y,
                id: canvas.getNextId(),
                stroke: "#000000",
                "stroke-width": wallWidth,
                "stroke-linecap": "round",
            },
        });
        canvas.addToSelection([lineElem], false);
        canvas.call("changed", [lineElem]);
        setTool("select");
    }, [svgCanvasInstanceRef, wallWidth, setTool]);
    const handleAddDoor = useCallback((point) => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas)
            return;
        const halfLength = 30;
        const lineElem = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: point.x - halfLength,
                y1: point.y,
                x2: point.x + halfLength,
                y2: point.y,
                id: canvas.getNextId(),
                stroke: "#00FF00",
                "stroke-width": wallWidth,
                "stroke-linecap": "round",
            },
        });
        canvas.addToSelection([lineElem], false);
        canvas.call("changed", [lineElem]);
        setTool("select");
    }, [svgCanvasInstanceRef, wallWidth, setTool]);
    const handleAddWindow = useCallback((point) => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas)
            return;
        const halfLength = 25;
        const lineElem = canvas.addSVGElementsFromJson({
            element: "line",
            curStyles: false,
            attr: {
                x1: point.x - halfLength,
                y1: point.y,
                x2: point.x + halfLength,
                y2: point.y,
                id: canvas.getNextId(),
                stroke: "#C8C8C8",
                "stroke-width": wallWidth,
                "stroke-linecap": "round",
            },
        });
        canvas.addToSelection([lineElem], false);
        canvas.call("changed", [lineElem]);
        setTool("select");
    }, [svgCanvasInstanceRef, wallWidth, setTool]);
    const handleAddText = useCallback(() => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas || !textValue.trim())
            return;
        const textElem = canvas.addSVGElementsFromJson({
            element: "text",
            curStyles: false,
            attr: {
                x: 400,
                y: 300,
                id: canvas.getNextId(),
                "font-size": 20,
                fill: theme.palette.primary.main,
                "font-family": "Roboto",
                stroke: "none",
            },
        });
        if (textElem && textElem instanceof SVGElement) {
            textElem.textContent = textValue;
            canvas.addToSelection([textElem], false);
            canvas.call("changed", [textElem]);
            setTool("select");
            setTextValue("");
        }
    }, [svgCanvasInstanceRef, textValue, theme.palette.primary.main, setTool, setTextValue]);
    const handleAddTextAtPosition = useCallback((point) => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas || !textValue.trim())
            return;
        const textElem = canvas.addSVGElementsFromJson({
            element: "text",
            curStyles: false,
            attr: {
                x: point.x,
                y: point.y,
                id: canvas.getNextId(),
                "font-size": 20,
                fill: theme.palette.primary.main,
                "font-family": "Roboto",
                stroke: "none",
            },
        });
        if (textElem && textElem instanceof SVGElement) {
            textElem.textContent = textValue;
            canvas.addToSelection([textElem], false);
            canvas.call("changed", [textElem]);
            setTool("select");
            setTextValue("");
        }
    }, [svgCanvasInstanceRef, textValue, theme.palette.primary.main, setTool, setTextValue]);
    const handleAddRectangle = useCallback(() => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas)
            return;
        const rectElem = canvas.addSVGElementsFromJson({
            element: "rect",
            curStyles: false,
            attr: {
                x: 350,
                y: 250,
                width: 100,
                height: 100,
                id: canvas.getNextId(),
                fill: "none",
                stroke: "#000000",
                "stroke-width": wallWidth,
            },
        });
        canvas.addToSelection([rectElem], false);
        canvas.call("changed", [rectElem]);
        setTool("select");
    }, [svgCanvasInstanceRef, wallWidth, setTool]);
    const handleDelete = useCallback(() => {
        const canvas = svgCanvasInstanceRef.current;
        if (!canvas)
            return;
        const selectedElements = canvas.getSelectedElements();
        if (selectedElements.length > 0) {
            selectedElements.forEach((elem) => {
                canvas.deleteSelectedElements(false);
            });
            canvas.clearSelection();
            canvas.call("changed", selectedElements);
        }
    }, [svgCanvasInstanceRef]);
    return {
        handleAddWall,
        handleAddDoor,
        handleAddWindow,
        handleAddText,
        handleAddTextAtPosition,
        handleAddRectangle,
        handleDelete,
    };
};
